import { AddPopoutSource, addPopoutV2 } from 'owa-popout-v2';

export default function popoutReadingPane(vdir: 'mail', itemId: string, source?: AddPopoutSource) {
    const route = 'read/' + encodeURIComponent(itemId);

    addPopoutV2(vdir, route);
}
